import React, { createContext, useContext, useState, ReactNode } from "react";

type ChatType = "All Conversations" | "Company" | "Customers" | "Users";

interface MessageContextProps {
  chatType: ChatType;
  setChatType: (value: ChatType) => void;
  // Add more message-related state here later
}

const MessageContext = createContext<MessageContextProps | undefined>(undefined);

export const MessageProvider = ({ children }: { children: ReactNode }) => {
  const [chatType, setChatType] = useState<ChatType>("All Conversations");

  return (
    <MessageContext.Provider value={{ chatType, setChatType }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageContext = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useMessageContext must be used within a MessageProvider");
  }
  return context;
};
